import {
  PaymentMethodsService
} from '@/common/api.service'
import {
  FETCH_PAYMENT_METHODS,
  PAYMENT_METHOD_CREATE,
  PAYMENT_METHOD_UPDATE,
  PAYMENT_METHOD_DELETE
} from './actions.type'
import {
  FETCH_START,
  FETCH_END
} from './mutations.type'

const state = {
  paymentMethods: [],
  isLoading: true,
  paymentMethodsCount: 0
}

const getters = {
  paymentMethodsCount (state) {
    return state.paymentMethodsCount
  },
  paymentMethods (state) {
    return state.paymentMethods
  }
}

const actions = {
  [FETCH_PAYMENT_METHODS] ({ commit }, params) {
    commit(FETCH_START)
    return PaymentMethodsService.query(params.type, params.filters)
      .then(({ data }) => {
        let collection = { paymentMethods: data.data, paymentMethodsCount: data.pagination.total }
        commit(FETCH_END, collection)
      })
      .catch((error) => {
        throw new Error(error)
      })
  },
  [PAYMENT_METHOD_CREATE] ({state}, item) {
    return PaymentMethodsService.create(item)
  },
  [PAYMENT_METHOD_UPDATE] ({state}, item) {
    return PaymentMethodsService.update(item.id, item)
  },
  [PAYMENT_METHOD_DELETE] (context, id) {
    return PaymentMethodsService.destroy(id)
  }
}

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_START] (state) {
    state.isLoading = true
  },
  [FETCH_END] (state, { paymentMethods, paymentMethodsCount }) {
    state.paymentMethods = paymentMethods
    state.paymentMethodsCount = paymentMethodsCount
    state.isLoading = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
